import React, {useCallback, useEffect, useState} from 'react';
import FormControl from '@material-ui/core/FormControl';
import MuiSelect from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Trans } from "../utils/i18n";
import {Autocomplete} from "@material-ui/lab";
import {Chip} from "@material-ui/core";

const MetaPicker =  function({ disabled, field, input, meta: { touched, error } }) {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        fetch(route('order.meta', {key: field.key}))
            .then(response => response.json())
            .then(response => {
                if(!response.success) {
                    throw 'error';
                }
                setOptions(response.data ?? []);
            })

    }, [])

    const onChange = useCallback((event, value) => {
        input.onChange(value);
    }, [input]);

    return (
        <Autocomplete
            multiple
            id="tags-filled"
            options={options.map((option) => option.value)}
            freeSolo
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={field.label}
                    placeholder="Favorites"
                    helperText={touched && error }
                    error={touched && error}
                />
            )}
            onChange={onChange}
            value={Array.isArray(input.value) ? input.value : []}
        />
    )
}

export default MetaPicker
